var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54438 6C6.68725 6 6 6.675 6 7.5V18C6 18.3978 6.16271 18.7794 6.45234 19.0607C6.74196 19.342 7.13478 19.5 7.54438 19.5H18.355C18.7646 19.5 19.1574 19.342 19.4471 19.0607C19.7367 18.7794 19.8994 18.3978 19.8994 18V16.29C20.355 16.0275 20.6716 15.555 20.6716 15V10.5C20.6716 9.945 20.355 9.4725 19.8994 9.21V7.5C19.8994 7.10218 19.7367 6.72064 19.4471 6.43934C19.1574 6.15804 18.7646 6 18.355 6H7.54438ZM7.54438 7.5H18.355V9H13.7219C13.3123 9 12.9195 9.15804 12.6298 9.43934C12.3402 9.72064 12.1775 10.1022 12.1775 10.5V15C12.1775 15.3978 12.3402 15.7794 12.6298 16.0607C12.9195 16.342 13.3123 16.5 13.7219 16.5H18.355V18H7.54438V7.5ZM13.7219 10.5H19.1272V15H13.7219V10.5ZM16.0385 11.625C15.7313 11.625 15.4366 11.7435 15.2194 11.9545C15.0022 12.1655 14.8802 12.4516 14.8802 12.75C14.8802 13.0484 15.0022 13.3345 15.2194 13.5455C15.4366 13.7565 15.7313 13.875 16.0385 13.875C16.3456 13.875 16.6403 13.7565 16.8575 13.5455C17.0747 13.3345 17.1967 13.0484 17.1967 12.75C17.1967 12.4516 17.0747 12.1655 16.8575 11.9545C16.6403 11.7435 16.3456 11.625 16.0385 11.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.cdf80415770632d9e34092d3ddf1f1ec.svg";
export { ForwardRef as ReactComponent };